import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-password-expired',
  templateUrl: './password-expired.component.html',
  styleUrls: ['./password-expired.component.scss'],
})
export class PasswordExpiredDialogComponent implements OnInit {
  dateToExpired: string;
  constructor(
    private dialogRef: MatDialogRef<PasswordExpiredDialogComponent>,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.dateToExpired = data;
  }

  ngOnInit(): void {}

  public accept(): void {
    this.dialogRef.close({ logout: true });
  }
}
